const GET_VERTICAL_DETAILS = "GET_VERTICAL_DETAILS";
const GET_VERTICAL_DETAILS_SUCCESS = "GET_VERTICAL_DETAILS_SUCCESS";
const GET_VERTICAL_DETAILS_FAILURE = "GET_VERTICAL_DETAILS_FAILURE";
const CLEAR_GET_VERTICAL_DETAILS = "CLEAR_GET_VERTICAL_DETAILS";

const verticalDetailsSymbols = {
  GET_VERTICAL_DETAILS_SUCCESS,
  GET_VERTICAL_DETAILS_FAILURE,
  GET_VERTICAL_DETAILS,
  CLEAR_GET_VERTICAL_DETAILS,
};
export default verticalDetailsSymbols;
